<app-container>
  <app-header id="header"></app-header>
  <div class="grow">
    <div class="galleria-container flex">
      <app-gallery [images]="images()"></app-gallery>
    </div>
  </div>
  <app-intro-dialog></app-intro-dialog>
</app-container>
